import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ImageDto } from 'src/assets/common/models/image-dto.g';
import { ILogosDto } from 'src/assets/common/models/logos-dto.g';
import { RouteActionParam, routeActionParam } from 'src/app/infrastructure/services/page-services/models/return-page-query-param';
import { _LevelGlobalPageService } from 'src/app/infrastructure/services/page-services/_level-global-page.service';
import { imageName, logoName, TImageName } from 'src/app/infrastructure/models/image-type';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { domainUserData, IDomainUserData } from '../../domain-user/models/domain-user-data';
import { ApplicationUserService } from 'src/app/infrastructure/services/application-user.services/application-user.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { ApiService } from 'src/app/infrastructure/services/api-service/api.service';
import { IDomainUserListData } from '../../domain-user/models/domain-user-list-data';

@Injectable()
export class DomainPageService
    extends _LevelGlobalPageService
{
    private readonly __apiService = injectRequired(ApiService);
    private readonly __applicationUserService = injectRequired(ApplicationUserService);

    constructor() {
        super(
            routePage.domainCreate,
        )
    }

    override pageCreate_goto = this._createPage_goto;

    keyPhoto_goto(photoDto: ImageDto) {
        this.image_goto(imageName.domainPhoto, photoDto);
    }

    logo_upload$(file: File): Observable<ILogosDto> {
        return this.__logo_upload$(file);
    }

    logoEmail_upload$(file: File): Observable<ILogosDto> {
        // Route-gescopede dauGuid (niet het globale domainUserData): dit component kan het
        // AdminPanel zijn, dat een ANDER domein beheert dan waar domainUserData toevallig
        // (van een willekeurige eerdere API-response elders in de app) naar wijst.
        const dauGuid = this._activatedRouteService?.routeKeys?.dauGuid;
        const formData = new FormData();
        formData.append('file', file, file.name);
        return from(this.__apiService.POST('/api/Logo/upload-email', {
            params: { query: { domainAUserGuid: dauGuid ?? undefined } },
            body: formData as any,
        })).pipe(map(r => r.data as unknown as ILogosDto));
    }

    logo_goto(logoDto: ImageDto) {
        this.image_goto(logoName.logo, logoDto);
    }

    logoEmail_goto(logoDto: ImageDto) {
        this.image_goto(logoName.logoEmail, logoDto);
    }

    // version: guid blijft gelijk bij een logo-herupload (in-place overschreven), dus zonder
    // ?v= cache-bust in de route blijft ImageDetails (Cache-Control: immutable) de oude,
    // gecachete afbeelding tonen — zelfs na hard-refresh. Meegeven vanuit ImageVersionService
    // (zie AdminDetailsComponent/DomainDetailsComponent.emit_logo_navigate).
    logo_image_goto(guid: string, version?: string | null): void {
        // Route-gescopede dauGuid — zie logoEmail_upload$ hierboven.
        const dauGuid = this._activatedRouteService?.routeKeys?.dauGuid;
        if (!dauGuid || !guid) return;
        this.page_goto(routePage.image, { dauGuid, key: guid }, [routeActionParam.keep], { logoType: logoName.logo, ...(version ? { v: version } : {}) });
    }

    logoEmail_image_goto(guid: string, version?: string | null): void {
        // Route-gescopede dauGuid — zie logoEmail_upload$ hierboven.
        const dauGuid = this._activatedRouteService?.routeKeys?.dauGuid;
        if (!dauGuid || !guid) return;
        this.page_goto(routePage.image, { dauGuid, key: guid }, [routeActionParam.keep], { logoType: logoName.logoEmail, ...(version ? { v: version } : {}) });
    }

    image_goto(logoType: TImageName, imageDto: ImageDto) {
    }

    override pageRoute_goto(domainUser?: IDomainUserData | IDomainUserListData | null, keep?: RouteActionParam, routeParams?: {[key: string]: string}): void {
        const __domainUser = domainUser ?? this.__applicationUserService.domainUserData;
        const __dauGuid = __domainUser?.[domainUserData.guid];
        const __keep = keep ?? routeActionParam.none;

        if (!__dauGuid) return;

        this.page_goto(routePage.domain, {dauGuid: __dauGuid}, [__keep], routeParams);
    }


    private __logo_upload$(file: File): Observable<ILogosDto> {
        // Route-gescopede dauGuid — zie logoEmail_upload$ hierboven.
        const dauGuid = this._activatedRouteService?.routeKeys?.dauGuid;
        const formData = new FormData();
        formData.append('file', file, file.name);
        return from(this.__apiService.POST('/api/Logo/upload', {
            params: { query: { domainAUserGuid: dauGuid ?? undefined } },
            body: formData as any,
        })).pipe(map(r => r.data as unknown as ILogosDto));
    }
}
